(function (angular, schoolwork12) {
    
    'use strict';
    angular.module(schoolwork12.app.student.name)

    .factory(schoolwork12.app.student.services.studentAdjustAttendance, 
        ['$rootScope', '$http', '$uibModal', '$filter', '$q', schoolwork12.app.auth.services.authentication,
        function($rootScope, $http, $uibModal, $filter, $q, authentication) {      

  		var service  = function studentAdjustAttendance(selectedStudents, selectedStudentsCount) {
			var modalInstance = $uibModal.open({
			    templateUrl: schoolwork12.app.student.templates.studentAdjustAttendance,
			    size: 'lg',
			    backdrop: 'static',
			    controller: ['$scope', '$uibModalInstance',			   
		        function ($scope, $uibModalInstance) {
		       		console.log("Viewing Adjust Attendance for Students");
				
			    //initialize default settings
			    $scope.forms = {};
			    $scope.AttAdjustErrorMesg = "";
			    $scope.AttAdjustErrorOccurred = false;

			    $scope.AttAdjustStartDateMesg = "";
			    $scope.AttAdjustErrorStartDate = false;
			    $scope.AttAdjustEndDateMesg = "";
			    $scope.AttAdjustErrorEndDate = false;
			    $scope.AttAdjustPercentMesg = "";
                $scope.AttAdjustErrorPercent = false; 
                $scope.AttAdjustReasonMesg = "";
                $scope.AttAdjustErrorReason = false;  
                $scope.AttAdjustTypeMesg = "";
                $scope.AttAdjustErrorType = false; 

			    $scope.loadingAttAdjustErrorOccurred = false;
			    $scope.isSaveStudentAdjustAttBusy = false;			    
				$scope.studentsCount = selectedStudentsCount;
				$scope.adjustAtt = {};

				$scope.openStartDatePicker = function() {
	                $scope.openStartDatePickerFlag = true;
	            };

	            $scope.openEndDatePicker = function() {
	                $scope.openEndDatePickerFlag = true;
	            };

			    $http({
	                //get a list of reasons to adjust attendance
	                url : schoolwork12.app.student.endpoints.attendanceAdjReason,
	                method : 'GET',                        
	                headers : {
                                'X-API-TOKEN' : authentication.getCurrentUser().keycode,
                              }
                    }).then(function (response) {
                		$scope.studentAttendanceAdjReasonList = response.data; 
                		console.info('Got the adjust attendance reason');
                    }, function(error) {
                       console.info('Error in retrieving adjust attendance reasons...'.concat(angular.toJson(error)));
                       $scope.loadingAttAdjustErrorOccurred = true;
                       $scope.attStudentsLoadingErrorMesg = schoolwork12.app.errorMessages.internalError
 
                    if (error.status == 400) {
                        for ( var j = 0; j < error.data._errors.length; j++) {
                               $scope.attStudentsLoadingErrorMesg = $scope.attStudentsLoadingErrorMesg + error.data._errors[j] + "\n";
                        }
                    } else if (error.status == 401 || error.status == 403) {
                        $scope.attStudentsLoadingErrorMesg = $scope.attStudentsLoadingErrorMesg + schoolwork12.app.errorMessages.sessionExpired;
                    }
                      
                });
                      
               $http({
                 	//get a list of types to adjust attendance
                 	url : schoolwork12.app.student.endpoints.attendanceAdjType,
                 	method : 'GET',                        
                   	headers : {
                             	'X-API-TOKEN' : authentication.getCurrentUser().keycode,
                              }
                   	}).then(function (response) {
                    	$scope.studentAttendanceAdjTypeList = response.data; 
                    	console.info('Got the adjust attendance type');
                    }, function(error) {
                       console.info('Error in retrieving adjust attendance types...'.concat(angular.toJson(error)));
                       $scope.loadingAttAdjustErrorOccurred = true;
                       $scope.attStudentsLoadingErrorMesg = schoolwork12.app.errorMessages.internalError
 
                    if (error.status == 400) {
                        for ( var j = 0; j < error.data._errors.length; j++) {
                               $scope.attStudentsLoadingErrorMesg = $scope.attStudentsLoadingErrorMesg + error.data._errors[j] + "\n";
                        }
                 	} else if (error.status == 401 || error.status == 403) {
                        $scope.attStudentsLoadingErrorMesg = $scope.attStudentsLoadingErrorMesg + schoolwork12.app.errorMessages.sessionExpired;
                    }
                     
                });
 
				$scope.cancel = function () {
				    $uibModalInstance.dismiss('cancel');
				};

				$scope.closeErrorMsg = function() {
                    $scope.AttAdjustErrorOccurred = false;
                }  

				$scope.studentAdjustAttendance = function(){
					resetErrorFlags();
					$scope.isSaveStudentAdjustAttBusy = true;

                    if ($scope.isFormValid()) {
             	    // save student's attendance adjustment
                    	$http({
			              	url : schoolwork12.app.student.endpoints.studentAdjustAttendance,
			              	method : "POST",
			              	data : {
			              			startDate: $filter('date')($scope.adjustAtt.startDate, 'MM/dd/yyyy'),
			              			endDate: $filter('date')($scope.adjustAtt.endDate, 'MM/dd/yyyy'),
			              			percent: $scope.adjustAtt.percent,
			              			reasonId: $scope.adjustAtt.reason,
								    typeId: $scope.adjustAtt.type,
								    excuser: $scope.adjustAtt.excuser,
								    comments: $scope.adjustAtt.comments,
								    students: selectedStudents
									},
		        		  	headers : {
										'X-API-TOKEN' : authentication.getCurrentUser().keycode,
									}
			              	}).then(function (response) {
			              		console.info("Saved students Attendance Adjustment successfully", response.data);
	            	   			$scope.AttAdjustErrorOccurred = false;
	            	   			$rootScope.actionCompletedSuccessfully = true;
	            	   			$rootScope.actionCompletedSuccessfullyMessage = "You have successfully adjusted attendance."
			              		$uibModalInstance.close();
			              	
                        	}, function(error) {
			              		$scope.AttAdjustErrorOccurred = true;
			                	console.info('Error in saving Attendance Adjustment...'.concat(angular.toJson(error)));
			                	if (error.status == 400) {
			                		$scope.AttAdjustErrorMesg = schoolwork12.app.student.modalErrMessages.adjustAttendanceFailed;
								} else if (error.status == 401 || error.status == 403) {
			                        $scope.AttAdjustErrorMesg = schoolwork12.app.errorMessages.sessionExpired;
			                    } else {
			                        $scope.AttAdjustErrorMesg = schoolwork12.app.errorMessages.internalError;
			                    }
			            	});

                    } else {
                    	$scope.isSaveStudentAdjustAttBusy = false;
                    }
				}

				$scope.isFormValid = function(){
					//validations for form fields
					for (var i = 0; i < selectedStudents.length; i++) {
	                    if (selectedStudents[i] != null) {
	                        $scope.schoolStartDate = selectedStudents[i].schoolStartDate; 
	                        $scope.schoolEndDate = selectedStudents[i].schoolEndDate; 
	                    }
	                };

					var selectedStartDate = new Date($scope.adjustAtt.startDate); 
					var selectedEndDate = new Date($scope.adjustAtt.endDate); 
					var formattedSchoolStartDate = new Date($scope.schoolStartDate);
					var formattedSchoolEndDate = new Date($scope.schoolEndDate);

					console.info("Validating attendance start date");
					if ($scope.adjustAtt.startDate == null ||
					    $scope.adjustAtt.startDate== "") {
						var val = $("#attStartDate").val();
						var d = new Date(val);
						if((val != null && val != "") && d == 'Invalid Date'){
							$scope.AttAdjustErrorStartDate = true;
							$scope.AttAdjustStartDateMesg = schoolwork12.app.student.errorMessages.attStartDateWrongFormat;	
						}else{
							$scope.AttAdjustErrorStartDate = true;
							$scope.AttAdjustStartDateMesg = schoolwork12.app.student.errorMessages.attStartDateRequired;
						}
					} else if (selectedStartDate < formattedSchoolStartDate) {
						$scope.AttAdjustErrorStartDate = true;
						$scope.AttAdjustStartDateMesg = schoolwork12.app.student.errorMessages.attStartDateValidate;
					}
					
					console.info("Validating attendance end date");
					
					if ($scope.adjustAtt.endDate == null ||
					    $scope.adjustAtt.endDate== "") {
						
						var val = $("#attEndDate").val();
						var d = new Date(val);
						if((val != null && val != "") && d == 'Invalid Date'){
							$scope.AttAdjustErrorEndDate = true;
							$scope.AttAdjustEndDateMesg = schoolwork12.app.student.errorMessages.attEndDateWrongFormat;	
						}
						if($scope.adjustAtt.type == 2){
							$scope.AttAdjustErrorEndDate = true;
							$scope.AttAdjustEndDateMesg = schoolwork12.app.student.errorMessages.attEndDateExcused;
						} else if($scope.adjustAtt.type == 3){
							$scope.AttAdjustErrorEndDate = true;
							$scope.AttAdjustEndDateMesg = schoolwork12.app.student.errorMessages.attEndDateSchoolMarked;
						}
					} else if (selectedEndDate > formattedSchoolEndDate) { 
						$scope.AttAdjustErrorEndDate = true;
						$scope.AttAdjustEndDateMesg = schoolwork12.app.student.errorMessages.attEndDateValidate;
					} else if (selectedEndDate < selectedStartDate) {
						$scope.AttAdjustErrorEndDate = true;
						$scope.AttAdjustEndDateMesg = schoolwork12.app.student.errorMessages.attEndDateWithStartDate;
					}
					
					console.info("Validating attendance percent");
					if ($scope.adjustAtt.percent == null ||
					    $scope.adjustAtt.percent== "") {
						$scope.AttAdjustErrorPercent = true;
						$scope.AttAdjustPercentMesg = schoolwork12.app.student.errorMessages.attPercentRequired; 
					} else if($scope.adjustAtt.percent && !/^([0-9][0-9]?$|^100)$/.test($scope.adjustAtt.percent)) {
						$scope.AttAdjustErrorPercent = true;
						$scope.AttAdjustPercentMesg = "Valid Percent is required";
					}

					console.info("Validating attendance reason");
					if ($scope.adjustAtt.reason == null ||
					    $scope.adjustAtt.reason== "") {
						$scope.AttAdjustErrorReason = true;
						$scope.AttAdjustReasonMesg = schoolwork12.app.student.errorMessages.attReasonRequired;
					}

					console.info("Validating attendance type");
					if ($scope.adjustAtt.type == null ||
					    $scope.adjustAtt.type== "") {
						$scope.AttAdjustErrorType = true;
						$scope.AttAdjustTypeMesg = schoolwork12.app.student.errorMessages.attTypeRequired; 
					}

					return !$scope.AttAdjustErrorStartDate && !$scope.AttAdjustErrorEndDate && 
					!$scope.AttAdjustErrorPercent && !$scope.AttAdjustErrorReason && !$scope.AttAdjustErrorType

				}
				
                           	
				var resetErrorFlags = function() {
                    // Control Error messages 
                    $scope.AttAdjustErrorMesg = "";
                    $scope.AttAdjustErrorOccurred = false; 
                    $scope.AttAdjustStartDateMesg = "";
                    $scope.AttAdjustErrorStartDate = false; 
                    $scope.AttAdjustEndDateMesg = "";
                    $scope.AttAdjustErrorEndDate = false; 
                    $scope.AttAdjustPercentMesg = "";
                    $scope.AttAdjustErrorPercent = false; 
                    $scope.AttAdjustReasonMesg = "";
                    $scope.AttAdjustErrorReason = false;  
                    $scope.AttAdjustTypeMesg = "";
                    $scope.AttAdjustErrorType = false;   
                    $rootScope.actionCompletedSuccessfully = false;
	            	$rootScope.actionCompletedSuccessfullyMessage = "";
                }

			}],
		  	    
		});

	};

    return {
    	service: service
    };

}]);
    
}(angular, schoolwork12));